import { Component, State, Prop, h, Element, Host } from '@stencil/core';
import { Comment } from './interfaces';
import CheckIcon from "../../assets/svg/check.svg"
import Reply from "../../assets/svg/reply.svg"

@Component({
  tag: 'salla-comment-item',
  styleUrl: 'salla-comments.scss',
})
export class SallaCommentItem {

  constructor() {
    salla.lang.onLoaded(() => {
      this.has_bought_trans = salla.lang.get('blocks.comments.has_bought')
      this.rated_trans = salla.lang.get('pages.rating.rated')
      this.waiting_approval_trans = salla.lang.get('blocks.comments.waiting_approval')
      this.has_order_trans = salla.lang.get('blocks.comments.has_order')
    })
  }
  @Element() host: HTMLElement;

  /**
   * Single Comment Instance
  */
  @Prop() comment: Comment;

  // Translations
  @State() has_bought_trans = salla.lang.get('blocks.comments.has_bought')
  @State() rated_trans = salla.lang.get('pages.rating.rated')
  @State() waiting_approval_trans = salla.lang.get('blocks.comments.waiting_approval')
  @State() has_order_trans = salla.lang.get('blocks.comments.has_order')

  private getReplies() {
    return Array.isArray(this.comment.replies) ? this.comment.replies : [this.comment.replies]
  }

  private getDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    return formattedDate;
  }
  private getTime(dateString) {
    const date = new Date(dateString);
    const formattedTime = `${date.getHours()}:${date.getMinutes()}`;
    return formattedTime;
  }
  render() {
    let isAdmin = this.comment.type == 'admin';
    return (
      <Host class={isAdmin ? 's-comments-item-admin' : 's-comments-item'}>
        <div class={{ "s-comments-item-wrapper": !isAdmin, "s-comments-item-admin-wrapper": isAdmin }} id={`s-comments-item-${this.comment.id}`}>
          <div class="s-comments-item-inner s-comments-flex-1">
            {isAdmin && <span class="s-comments-item-reply-icon" innerHTML={Reply}></span>}
            <div class="s-comments-item-avatar">
              <img data-src={this.comment?.avatar}
                alt={this.comment?.name} src={this.comment?.avatar}
                class="s-comments-item-avatar-img lazy" />
            </div>
            <div class="s-comments-flex-1">
              <div class="s-comments-item-user-wrapper">
                <div class="s-comments-item-user-info">
                  <h3 class="s-comments-item-user-info-name">{this.comment?.name}</h3>

                  {(this.comment.has_order || !!this.comment.rating) && !this.comment.is_pending ?
                    <div class="s-comments-flex">
                      {this.comment.has_order ?
                        [<span class="s-comments-item-has-order-check-icon" innerHTML={CheckIcon}></span>,
                        <span class="s-comments-item-has-order-check-text">
                          {this.has_bought_trans} {this.comment.rating ? ', ' : ''}
                        </span>] : null
                      }
                      {!!this.comment.rating ?
                        <span class="s-comments-item-rated-widget">{
                          this.rated_trans}</span> : null}
                    </div>
                    : null}
                </div>

                <p class="s-comments-item-timestamp s-ltr"> {this.getDate(this.comment.created_at?.date)} <span class="s-comments-item-time"> - {this.getTime(this.comment.created_at?.date)} </span></p>

                {!!this.comment.rating ?
                  <salla-rating-stars size="mini" class="s-comments-item-stars" value={this.comment.rating}></salla-rating-stars>
                  : null}
              </div>

              <div class="s-comments-item-content">
                <p>{this.comment.content}</p>
                {this.comment.is_pending ?
                  <span
                    class="s-comments-item-pending-text">{this.waiting_approval_trans}</span> : null}
                {/* {this.comment.has_order ?
                  <span data-toggle="tooltip" data-placement="right">{this.has_order_trans}</span>
                  : null} */}
              </div>
            </div>
          </div>
          {!!this.getReplies().length && !isAdmin ?
            this.getReplies().map((reply: Comment) => {
              return <div><salla-comment-item comment={reply}></salla-comment-item></div>
            }) : null}
        </div>
      </Host>
    );
  }

}
